import { ViewBasic } from '@quatrecentquatre/manage-me';
import { bindAll } from 'underscore'
import barba from "@barba/core";

export class MonerisIframe extends ViewBasic{
    //used by CardDisplay to receive the new card design
    static CARD_UPDATE_VISUAL = 'card.update_visual';

    constructor(options) {
        super(options);

        this.monerisTicket = this.params.moneris_ticket;
    }

    initialize() {
        bindAll(this, ['responseHandler']);
        this.myCheckout = new monerisCheckout();

        this.addEvents();
    }

    addEvents(){
        this.myCheckout.setMode(process.env.MONERIS_ENVIRONMENT ?? 'qa');
        this.myCheckout.setCheckoutDiv("monerisCheckout");
        this.myCheckout.setCallback("page_loaded", this.responseHandler);
        this.myCheckout.setCallback("payment_complete", this.responseHandler);
        this.myCheckout.setCallback("cancel_transaction", this.responseHandler);
        this.myCheckout.setCallback("error_event", this.responseHandler);
        this.myCheckout.setCallback("payment_submitted", this.responseHandler);
        this.myCheckout.startCheckout(this.monerisTicket);
    };

    removeEvents(){

    };

    /**
     * Press submit button
     * @param e
     */
    responseHandler(e){
        let scope = this;
        let response = JSON.parse(e);

        if(response.handler === 'payment_complete'){
            grecaptcha.ready(function() {
                //execute recaptcha
                grecaptcha.execute(window.SETTINGS.RECAPTCHA_SITE_KEY, {action: 'submit'}).then(function(token) {
                     // Récupérer le token CSRF depuis l'input caché
                    const csrfToken = scope.el.querySelector('input[name="csrf_token"]').value;


                    // Créer FormData au lieu de JSON pour que PHP puisse lire $_POST
                    const formData = new FormData();
                    formData.append('g-recaptcha-response', token);

                    // Ajouter tous les autres champs de response
                    Object.keys(response).forEach(key => {
                        if (key !== 'g-recaptcha-response') {
                            formData.append(key, response[key]);
                        }
                    });

                    formData.append('fields[form_contest]', scope.el.querySelector('input[name="fields[form_contest]"]')?.checked || false);

                    scope.myCheckout.closeCheckout(scope.monerisTicket);

                    fetch(scope.params.submit_url, {
                        method: 'POST',
                        headers: {
                            'X-CSRF-Token': csrfToken
                        },
                        body: formData
                    })
                    .then(response => response.json())
                    .then(data => {
                        if(data.success){
                            barba.go(data.redirectUrl);
                        } else {
                            console.log('data', data);
                            scope.monerisTicket = data.moneris_ticket;

                            scope.el.querySelector('#error-message-container').textContent = data.errors[0];
                            scope.el.querySelector('#error-message-container').style.display = 'block';

                            scope.el.querySelector('#error-message-container').scrollIntoView({ behavior: 'smooth', block: 'center' });

                            setTimeout(() => {
                                scope.myCheckout.startCheckout(scope.monerisTicket);
                            }, 0);
                        }
                    });
                });
            });
        } else if(response.handler === 'cancel_transaction'){
            barba.go(this.params.cancel_url);
        }
    }

    terminate(){
        this.removeEvents();
    };
}

Me.views['MonerisIframe'] = MonerisIframe;
